module.exports = __webpack_public_path__ + "static/media/loc1_img20.3d6150ed.jpg";